/* libs */
import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

/* action helpers */
import * as ActionTypes from "../../actions/actionTypes";
import * as ThemesActions from "../../actions/themesActions";
import * as constants from "../../constants";

const createThemesLogic = createLogic({
	type: ActionTypes.GET_THEMES,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		//TODO: dispatch action for creating a loader
		const { appKey } = action;
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 20000,
					headers: { Authorization: "Bearer " + token },
				});

				api.get(`/apps/${appKey}/themes`)
					.then(res => {
						//TODO: dispatch action for stopping loader
						dispatch(ThemesActions.getThemesSuccess(res.data));
						done();
					})
					.catch(error => {
						//TODO: dispatch action for stopping loader
						dispatch(ThemesActions.getThemesFailure(error));
						done();
					});
			});
	},
});

export default [createThemesLogic];
